import { render, staticRenderFns } from "./PrintPageWrapper.vue?vue&type=template&id=6e5f4b2a"
import script from "./PrintPageWrapper.vue?vue&type=script&lang=ts"
export * from "./PrintPageWrapper.vue?vue&type=script&lang=ts"
import style0 from "./PrintPageWrapper.vue?vue&type=style&index=0&id=6e5f4b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports